import { useEffect } from "react";

const useSetDocumentTitle = (title?: string): void => {
  useEffect(() => {
    document.title = title ?? "TALANTA - Образовательная платформа с онлайн-курсами";
  }, [title]);
};

export default useSetDocumentTitle;
